import React from 'react';
import { X } from 'lucide-react';

// Reusable "active filters" chip bar with one-click Clear all.
// Props:
//   filters: [{ key, label, set (Set), options ([{value,label}]), onChange (newSet) }]
//   search:  optional current search string
//   onClearSearch: optional handler to clear the search
export const ActiveFiltersBar = ({ filters = [], search, onClearSearch, testId = 'active-filters' }) => {
  const active = filters.filter(f => f.set && f.set.size > 0);
  const hasSearch = !!search;
  if (active.length === 0 && !hasSearch) return null;

  const labelFor = (f, v) => (f.options?.find(o => String(o.value) === String(v))?.label) ?? v;
  const removeVal = (f, v) => f.onChange(new Set([...f.set].filter(x => x !== v)));
  const clearAll = () => {
    filters.forEach(f => { if (f.set && f.set.size) f.onChange(new Set()); });
    if (onClearSearch) onClearSearch();
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <span className="text-xs text-muted-foreground font-medium">Active filters:</span>
      {hasSearch && (
        <span className="inline-flex items-center gap-1 rounded-full border bg-card text-xs px-2.5 py-1" data-testid={`${testId}-search`}>
          <span className="text-muted-foreground">Search:</span> &quot;{search}&quot;
          <button onClick={onClearSearch} className="ml-0.5 text-muted-foreground hover:text-red-600 transition-colors" data-testid={`${testId}-remove-search`}>
            <X className="w-3 h-3" />
          </button>
        </span>
      )}
      {active.flatMap(f => [...f.set].map(v => (
        <span key={`${f.key}-${v}`} className="inline-flex items-center gap-1 rounded-full bg-secondary text-secondary-foreground text-xs px-2.5 py-1" data-testid={`${testId}-chip-${f.key}-${v}`}>
          <span className="font-medium">{f.label}:</span> {labelFor(f, v)}
          <button onClick={() => removeVal(f, v)} className="ml-0.5 hover:text-red-600 transition-colors" data-testid={`${testId}-remove-${f.key}-${v}`}>
            <X className="w-3 h-3" />
          </button>
        </span>
      )))}
      <button onClick={clearAll} className="inline-flex items-center gap-1 text-xs text-red-600 hover:underline ml-1" data-testid={`${testId}-clear-all`}>
        <X className="w-3 h-3" />Clear all
      </button>
    </div>
  );
};

export default ActiveFiltersBar;
